module.exports = __webpack_public_path__ + "static/media/arrow-icon-full-black-up.40869c0d.svg";